export default __webpack_public_path__ + "static/media/republic-logo.86c4206a.png";